import React from "react";
import { Badge, Btn } from "../../../ForBrands/ui/BrandUI";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { FilterMenu } from "./allocationUi";

const FILTERS = [
  ["position", "Position"],
  ["number", "Number"],
  ["classification", "Classification"],
];

const Count = ({ count }) => (
  <Badge tone="outline">
    {count} player{count === 1 ? "" : "s"}
  </Badge>
);

// Roster head on phones (2415:1584): title and count, the filter chips on a
// row that wraps (not a scroller: it would clip their option lists), then
// Manage roster and Add player as two 52px buttons sharing the width.
const PhoneRosterToolbar = ({ count, options, filters, onFilter, onManage, onAdd, canManage, canAdd }) => (
  <div className="flex flex-col gap-3">
    <div className="flex items-center gap-2">
      <h2 className="bm-h-s text-bm-ink">Team Roster</h2>
      <Count count={count} />
    </div>
    <div className="relative flex flex-wrap gap-2">
      {FILTERS.map(([key, label]) => (
        <FilterMenu key={key} fill label={label} value={filters[key]} options={options[key]} onChange={(v) => onFilter(key, v)} />
      ))}
    </div>
    <div className="flex gap-3">
      {canManage && (
        <Btn size="lg" variant="secondary" onClick={onManage} className="min-w-0 flex-1 !px-4">
          Manage roster
        </Btn>
      )}
      <Btn size="lg" onClick={onAdd} disabled={!canAdd} className="min-w-0 flex-1 !px-4">
        Add player
      </Btn>
    </div>
  </div>
);

// Figma 03b · Roster head: title and count, the three filter chips, then
// Manage roster and Add player.
const RosterToolbar = (props) => {
  const phone = usePhoneTheme();
  if (phone) return <PhoneRosterToolbar {...props} />;
  const { count, options, filters, onFilter, onManage, onAdd, canManage, canAdd } = props;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-5">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="bm-h-s text-bm-ink">Team Roster</h2>
        <Count count={count} />
        <div className="flex flex-wrap items-center gap-2 sm:ml-5">
          {FILTERS.map(([key, label]) => (
            <FilterMenu key={key} label={label} value={filters[key]} options={options[key]} onChange={(v) => onFilter(key, v)} />
          ))}
        </div>
      </div>
      <div className="flex items-center gap-3">
        {canManage && (
          <Btn variant="secondary" onClick={onManage} className="min-w-[139px]">
            Manage roster
          </Btn>
        )}
        <Btn onClick={onAdd} disabled={!canAdd}>
          Add player
        </Btn>
      </div>
    </div>
  );
};

export default RosterToolbar;
